<template>
  <div class="main-body">
    <jm-crumbs ref="cvm"/>
    <jm-toolbar
      ref="toolbarvm"
      customize-field-name="student"
      show-defined-search
      show-defined-list>
      <template v-if="isFibSite">
        <router-link
          slot="beforeDefinedSearch"
          class="button-search icon-index-1"
          target="_blank"
          v-if="[83295, /*798389,*/].indexOf(userInfo.userid) === -1"
          :to="{ name: 'addStudent' }">
          <el-button
            type="primary"
            size="medium">添加学生信息</el-button>
        </router-link>
        <a
          slot="beforeDefinedSearch"
          class="button-search icon-index-2"
          href="/frontend/student/studentImport">
          <el-button
            type="primary"
            size="medium">资源导入</el-button>
        </a>
        <!--455187 批量同步 干掉 春旭-->
        <a
          slot="beforeDefinedSearch"
          class="button-search icon-index-2"
          v-if="[1, 2243703, 455174, 2263750, 2248733].indexOf(userInfo.userid) !== -1"
          href="/frontend/student/trainingList">
          <el-button
            type="primary"
            size="medium">批量同步</el-button>
        </a>
      </template>
      <el-button
        v-show="false"
        size="medium"
        slot="afterDefinedSearch"
        type="success">导出</el-button>
    </jm-toolbar>

    <el-tabs
      v-model="activeName"
      @tab-click="changeTab">
      <el-tab-pane
        name="first">
        <span slot="label">学生管理</span>
      </el-tab-pane>
      <el-tab-pane
        name="second">
        <span slot="label">公海资源<el-badge :value="waterNewCounts" /></span>
      </el-tab-pane>
      <div
        class="input-area none-month"
        @keyup.enter="inputAreaKeyup">
        <div :class="searchHiddenLock ? 'search-input-wrap active' : 'search-input-wrap'">
          <div
            class="box-content"
            v-if="filterVisible('name')">
            <label class="form-tit">姓名</label>
            <el-input
              v-model.trim="searchData.name"
              class="jm-input175"/>
            <el-checkbox v-model="searchData.nameString">模糊搜索</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('nickname')">
            <label class="form-tit">昵称</label>
            <el-input
              v-model.trim="searchData.nickname"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="$hasPermission([])">
            <label class="form-tit">联系方式</label>
            <el-input
              v-model.trim="searchData.linklike"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('gender')">
            <label class="form-tit">性别</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.gender"
              dict-type="student"
              name="gender"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('birthday')">
            <label class="form-tit">生日</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.birthday"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="请选择"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('domicile')">
            <label class="form-tit">户籍地</label>
            <jm-areaselect
              :empty="true"
              v-model="searchData.domicile"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('currentAddress')">
            <label class="form-tit">现住址</label>
            <jm-areaselect v-model="searchData.currentAddress"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('highestRecord')">
            <label class="form-tit">最高学历</label>
            <jm-education-select
              v-model="education"
              clearable
              @change="setEducation"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('lastSchool')">
            <label class="form-tit">毕业学校</label>
            <jm-dict-select
              class="jm-input-common2"
              clearable
              type="dataset"
              v-model="searchData.lastSchool"
              dict-type="student"
              name="schoolType"/>
            <el-input
              v-model="searchData.lastSchoolInput"
              class="jm-input-common2"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('lastProfessional')">
            <label class="form-tit">专业名称</label>
            <el-input
              v-model="searchData['custom_major']"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('phone')">
            <label class="form-tit">电话</label>
            <el-input
              v-model.trim="searchData.phone"
              class="jm-input175"/>
            <el-checkbox
              class="no-content-item"
              v-model="searchData['no_tel']">无</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('tel_province')">
            <label class="form-tit">手机号归属地</label>
            <el-select
              v-model="searchData.phoneProvince"
              filterable
              class="jm-input135"
              clearable
              placeholder="请选择"
              @change="changePhoneProvince"
            >
              <el-option
                v-for="item in phoneOwnership.provinces"
                :label="item"
                :value="item"
                :key="item"/>
            </el-select>
            <el-select
              v-model="searchData.phoneCity"
              filterable
              class="jm-input135"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in phoneOwnership.cities"
                :label="item"
                :value="item"
                :key="item"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('signingStatus')">
            <label class="form-tit">签约状态</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.signingStatus"
              dict-type="student"
              name="customLevelType"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('customerClassification')">
            <label class="form-tit">客户分级</label>
            <el-select
              class="jm-input-common"
              clearable
              multiple
              v-model="searchData.customerClassification"
              placeholder="请选择">
              <el-option v-for="item in customLvTypeDs" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
            <!-- <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.customerClassification"
              dict-type="student"
              name="customLvType"
              :filter="crmLvFilter"
            /> -->
          </div>
          <div
            class="box-content"
            v-if="(filterVisible('customerClassification') && searchData.customerClassification.indexOf(58) >= 0)">
            <label class="form-tit">公海资源等级</label>
            <el-select
              class="jm-input-common"
              clearable
              v-model="searchData.internationalWatersRule"
              placeholder="请选择">
              <el-option v-for="rule in ds.international_waters_rule" :key="rule.key" :label="rule.name" :title="rule.intro" :value="rule.id"/>
            </el-select>
            <el-tooltip effect="dark">
              <div slot="content" style="width:400px">
                <table>
                  <caption><u>公海资源等级说明</u></caption>
                  <tr v-for="rule in ds.international_waters_rule" :key="rule.key">
                    <th align="left" valign="top" width="90">{{ rule.name }}： </th>
                    <td>{{ rule.intro }}</td>
                  </tr>
                </table>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
          <div class="box-content" v-if="filterVisible('contractNo')">
            <label class="form-tit">合同号</label>
            <el-input v-model="searchData.contractNo" class="jm-input-common" />
          </div>
          <div
            class="box-content"
            v-if="filterVisible('signingdate')">
            <label class="form-tit">签约日期</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.signingdate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('qq')">
            <label class="form-tit">QQ</label>
            <el-input
              v-model.trim="searchData.qq"
              class="jm-input-common"/>
            <el-checkbox
              class="no-content-item"
              v-model="searchData['no_qq']">无</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('WeChat')">
            <label class="form-tit">微信</label>
            <el-input
              v-model.trim="searchData.WeChat"
              class="jm-input-common"/>
            <el-checkbox
              class="no-content-item"
              v-model="searchData['no_wechat']">无</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('average')">
            <label class="form-tit">平均分</label>
            <el-input
              v-model="searchData.average"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('examScore')">
            <label class="form-tit">高考分数</label>
            <el-input
              v-model="searchData.examScore"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('startSchoolDate')">
            <label class="form-tit">入学时间</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.startSchoolDateYear"
              @change="() => { return this.searchData.startSchoolDateMonth = ''; }"
              type="year"
              placeholder="请选择"
              class="jm-input-common2"
              format="yyyy"
              value-format="yyyy"/>
            <el-date-picker
              :editable="false"
              v-model="searchData.startSchoolDateMonth"
              :disabled="!searchData.startSchoolDateYear"
              type="month"
              placeholder="请选择"
              class="jm-input-common2"
              popper-class="process-list-popper"
              format="MM"
              value-format="MM"/>
            <el-checkbox
              class="no-content-item"
              v-model="searchData['no_custom_year']">无</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('intentionCountries')">
            <label class="form-tit">意向国家</label>
            <el-select
              v-model="searchData.intentionCountries"
              class="jm-input-common"
              multiple
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
            <el-checkbox
              class="no-content-item"
              v-model="searchData.intentionCountriesEx">排除</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('activeCountries')">
            <label class="form-tit">办理国家</label>
            <el-select
              v-model="searchData.activeCountries"
              class="jm-input-common"
              multiple
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
            <el-checkbox
              class="no-content-item"
              v-model="searchData.activeCountriesEx">排除</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('apply_school')">
            <label class="form-tit">申请学校</label>
            <el-select
              v-model="searchData.apply_school"
              filterable
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.schoolInfo"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('is_parent_community')">
            <label class="form-tit">家长社群</label>
            <el-select
              class="jm-input-common"
              v-model="searchData['is_parent_community']">
              <el-option label="请选择" :value="-1"></el-option>
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('is_vip')">
            <label class="form-tit">芥末会员</label>
            <el-select
              class="jm-input-common"
              v-model="searchData['is_vip']">
              <el-option label="请选择" :value="-1"></el-option>
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('other_pushed')">
            <label class="form-tit">用户运营双推</label>
            <el-select
              class="jm-input-common"
              v-model="searchData['other_pushed']">
              <el-option label="请选择" :value="-1"></el-option>
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_writer')">
            <label class="form-tit">申请老师</label>
            <el-select
              v-model="searchData.crm_writer"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.write_teacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_sayer')">
            <label class="form-tit">咨询老师</label>
            <el-select
              v-model="searchData.crm_sayer"
              class="jm-input-common"
              clearable
              placeholder="请选择"
              filterable>
              <el-option-group
                v-for="(group, k) in ds.originAdvisoryTeacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="`${item.country}_${item.userid}`"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_planning')">
            <label class="form-tit">规划老师</label>
            <el-select
              v-model="searchData.crm_planning"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.planning_teacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_document')">
            <label class="form-tit">文书老师</label>
            <el-select
              v-model="searchData.crm_document"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.originDocumentTeacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_cse')">
            <label class="form-tit">客服老师</label>
            <el-select
              v-model="searchData.crm_cse"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.cse_teacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('crm_manager')">
            <label class="form-tit">客户经理</label>
            <el-select
              v-model="searchData.crm_manager"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.manager_teacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="false && filterVisible('crm_training')">
            <label class="form-tit">考培咨询</label>
            <el-select
              v-model="searchData.crm_training"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.training_teacher"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.truename"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="showCrmSchool && filterVisible('schoolInformation')">
            <label class="form-tit">选校信息</label>
            <el-select
              v-model="searchData.schoolInformation"
              filterable
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.schoolInfo"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('founder')">
            <label class="form-tit">创建人</label>
            <el-select
              v-model="searchData.create_person"
              filterable
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.create_person"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.username"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
            <el-checkbox
              class="no-content-item"
              v-model="searchData.excludeSelf">排除自己</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('exfounder')">
            <label class="form-tit">排除创建人</label>
            <el-select
              v-model="searchData.no_create_person"
              filterable
              class="jm-input-common"
              clearable
              multiple
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.create_person"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.username"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('create_point')">
            <label class="form-tit">采集功能</label>
            <el-select
              v-model="searchData.create_point"
              filterable
              class="jm-input-common"
              clearable
              multiple
              placeholder="请选择">
              <el-option
                v-for="item in createPersonZZ"
                :key="item.userid"
                :label="item.username"
                :value="item.userid"/>
            </el-select>
            <el-checkbox
              class="no-content-item"
              v-model="searchData.create_point_ex">排除</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('snapshot_create_point')">
            <label class="form-tit">重复进入采集功能</label>
            <el-select
              v-model="searchData.snapshot_create_point"
              filterable
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in createPersonZZ"
                :key="item.userid"
                :label="item.username"
                :value="item.userid"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('custom_promoter')">
            <label class="form-tit">推广人</label>
            <el-select
              v-model="searchData.custom_promoter"
              filterable
              class="jm-input-common"
              clearable
              multiple
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.create_person"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group.filter(item => item.userid > 0)"
                  :key="item.userid"
                  :label="item.username"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
            <el-checkbox
              class="no-content-item"
              v-model="searchData.custom_promoter_ex">排除</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('creationDate')">
            <label class="form-tit">创建日期</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.creationDate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('returndate')">
            <label class="form-tit">回访日期</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.returndate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('lastVisit')">
            <label class="form-tit">最后回访</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.lastvisittime2"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('returnNumber')">
            <label class="form-tit">回访次数</label>
            <el-input
              v-model="searchData.returnNumber1"
              class="jm-input-common3"/>
            <em>至</em>
            <el-input
              v-model="searchData.returnNumber2"
              class="jm-input-common3"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('returnRecord')">
            <label class="form-tit">回访记录</label>
            <el-input
              v-model="searchData.returnRecord"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content box-content-double"
            v-if="filterVisible('studentsDynamic')">
            <label class="form-tit">学生动态</label>
            <el-select
              class="jm-input-common2"
              clearable
              v-model="searchData['studentsDynamic']">
              <el-option
                v-for="(value, index) in ds.action_types"
                :key="index"
                :value="index"
                :label="value"/>
            </el-select>
            <!-- <jm-dict-select class="jm-input90" clearable type="dataset" v-model="searchData.studentsDynamic" dict-type="student" name="actionsType"></jm-dict-select> -->
            <el-date-picker
              :editable="false"
              v-model="searchData.studentsDynamicDate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('transferredResources')">
            <label class="form-tit">被转资源</label>
            <el-checkbox
              v-model="searchData.transferredResources"
              :key="7">被转资源</el-checkbox>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('project')">
            <label class="form-tit">项目</label>
            <el-select
              v-model="searchData.project"
              class="jm-input-common"
              filterable
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.projects"
                :label="`[${item.country}]${item.value}`"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('endorsePlan')">
            <label class="form-tit">代言计划</label>
            <jm-dict-select
              class="jm-input-common"
              v-model="searchData.endorsePlan"
              clearable
              type="dataset"
              dict-type="student"
              name="rugbyPeople"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('japanCourse')">
            <label class="form-tit">日本意向课程</label>
            <jm-dict-select
              v-model="searchData.custom_course"
              class="jm-input-common"
              clearable
              dict-type="course"
              :filter="(item) => { return item.pid === 83; }"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('dataSent')">
            <label class="form-tit">资料发送</label>
            <el-select
              v-model="searchData.dataSent"
              class="jm-input-common"
              filterable
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.material"
                :label="`${item.country} ${item.value}`"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('reviewStar') && $hasPermission([39, 43, 51, 73, 74])">
            <label class="form-tit">评星等级</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.reviewStar"
              name="crmStar"
              dict-type="student"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('selectPlan')">
            <label class="form-tit">择校规划</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.selectPlan"
              dict-type="student"
              name="chooseSchoolPlans"
              @change="selectPlanEvent"/>
            <el-tooltip>
              <div slot="content" style="width:400px">
                <table>
                  <caption><u>择校规划状态说明</u></caption>
                  <tr>
                    <th align="left" valign="top" nowrap>已做择校规划（全部）：</th>
                    <td>包括择校规划状态为“待提交”、“待学生确认”和“学生已确认”的学生；</td>
                  </tr>
                  <tr>
                    <th align="left" valign="top" nowrap>学生已确认：</th>
                    <td>择校规划状态为“学生已确认”的学生；</td>
                  </tr>
                  <tr>
                    <th align="left" valign="top" nowrap>待学生确认：</th>
                    <td>择校规划状态为“待学生确认”的学生；</td>
                  </tr>
                  <tr>
                    <th align="left" valign="top" nowrap>待提交：</th>
                    <td>择校规划状态为“待提交”的学生；</td>
                  </tr>
                  <tr>
                    <th align="left" valign="top" nowrap>已签约未做择校规划：</th>
                    <td>签约状态为“签约”，未做择校规划的学生；</td>
                  </tr>
                </table>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('id')">
            <label class="form-tit">客户编码</label>
            <el-input
              v-model="searchData.id"
              class="jm-input-common"/>
          </div>
          <div class="box-content" v-if="filterVisible('giveup_time')">
            <label class="form-tit">放弃时间</label>
            <el-date-picker class="jm-input-common" :editable="false" v-model="searchData.giveup_time" @change="changeGiveupTime" type="daterange" unlink-panels clearable placeholder="请选择" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('upgradePlanTeacher')">
            <label class="form-tit">升学指导老师</label>
            <el-input
              v-model="searchData.upgradePlanTeacher"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('school_schedule')">
            <label class="form-tit">留学时刻表</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              placeholder="请选择"
              type="dataset"
              v-model="searchData.school_schedule"
              dict-type="student"
              name="schedule"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('response_time')">
            <label class="form-tit">响应速度</label>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.responseTime1"
              dict-type="student"
              name="score"/>
            <em>到</em>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.responseTime2"
              dict-type="student"
              name="score"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('service_attitude')">
            <label class="form-tit">服务态度</label>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.serviceAttitude1"
              dict-type="student"
              name="score"/>
            <em>到</em>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.serviceAttitude2"
              dict-type="student"
              name="score"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('professional_degrees')">
            <label class="form-tit">专业度</label>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.professionalDegrees1"
              dict-type="student"
              name="score"/>
            <em>到</em>
            <jm-dict-select
              class="jm-input-common3"
              clearable
              type="dataset"
              v-model="searchData.professionalDegrees2"
              dict-type="student"
              name="score"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('mustard_qa')">
            <label class="form-tit">芥末问答</label>
            <el-checkbox v-model="searchData.mustard_qa"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('identity')">
            <label class="form-tit">身份类别</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.identity"
              dict-type="student"
              name="identity"/>
          </div>
          <div
            class="box-content box-radio-checkbox"
            v-if="$fv('sign_type')">
            <label class="form-tit">签约类型</label>
            <el-radio-group
              :max="1"
              size="mini"
              v-model="searchData.signTypeLevel">
              <el-radio :label="1">Standard</el-radio>
              <el-radio :label="2">Plus</el-radio>
              <el-radio :label="3">Free</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="searchData.signTypeKind">
              <el-checkbox :label="4">短期</el-checkbox>
              <el-checkbox :label="5">语培</el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="box-content box-content-double"
            v-if="filterVisible('channel')">
            <label class="form-tit">渠道来源</label>
            <jm-channel
              v-model="searchData.channel"
              clearable
              filterable/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('clues_level')">
            <label class="form-tit">线索分级</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.clues_level"
              name="cluesLevel"
              dict-type="student"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('custom_jp_note')">
            <label class="form-tit">留学目的</label>
            <jm-dict-select
              class="jm-input-common"
              v-model="searchData.custom_jp_note"
              dict-type="custom_jp_note"
              clearable/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('activity_code')">
            <label class="form-tit">活动编码</label>
            <el-input
              v-model="searchData.activity_code"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content box-content-double"
            v-if="filterVisible('upgradePlan')">
            <label class="form-tit">升学规划</label>
            <el-checkbox v-model="searchData.joinUpgradePlan">参加1对1升学规划</el-checkbox>
            <el-checkbox v-model="searchData.sendUpgradePlan">发送升学规划书</el-checkbox>
            <el-checkbox v-model="searchData.testUpgradePlan">参加试听课程</el-checkbox>
          </div>
          <!-- v-if="filterVisible('InternationalWaters')" -->
          <!-- <div class="box-content">
            <label class="form-tit">公海资源</label>
            <jm-dict-select
              clearable
              type="dataset"
              v-model="searchData.InternationalWaters"
              dict-type="student"
              name="isTover"/>
          </div> -->
          <div
            class="box-content"
            v-if="filterVisible('behavior')">
            <label class="form-tit">用户行为数</label>
            <el-input
              v-model="searchData.behaviorStart"
              class="jm-input-common3"
              clearable
              placeholder="请输入内容"/>
            <em>到</em>
            <el-input
              v-model="searchData.behaviorEnd"
              class="jm-input-common3"
              clearable
              placeholder="请输入内容"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('isJpHas')">
            <label class="form-tit">有无日语成绩</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.isJpHas"
              clearable
              placeholder="请选择">
              <el-option
                :key="1"
                label="有"
                :value="1"/>
              <el-option
                :key="2"
                label="无"
                :value="2"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('activation')">
            <label class="form-tit">激活次数</label>
            <el-input
              v-model="searchData.activationStart"
              class="jm-input-common3"
              clearable
              placeholder="请输入内容"/>
            <em>到</em>
            <el-input
              v-model="searchData.activationEnd"
              class="jm-input-common3"
              clearable
              placeholder="请输入内容"/>
          </div>
          <div
            class="box-content"
            v-if="false && filterVisible('signTheContract')">
            <label class="form-tit">考培签约</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.signTheContract"
              dict-type="student"
              name="customLevelType"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('examjp')">
            <label class="form-tit">日语成绩</label>
            <jm-examjp-select
              v-model="examjp"
              clearable
              @change="setExamjp"/>
          </div>
          <div
            class="box-content"
            v-if="false && filterVisible('examinationOfCulture')">
            <label class="form-tit">考培分级</label>
            <jm-dict-select
              class="jm-input-common"
              type="dataset"
              v-model="searchData.examinationOfCulture"
              dict-type="student"
              name="customLvType"
              :filter="crmKaopeiFilter"/>
          </div>
          <div
            class="box-content"
            v-if="false && filterVisible('culture_sign_date')">
            <label class="form-tit">考培签约日期</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.culture_sign_date"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('jiemo_vip')">
            <label class="form-tit">芥末日本vip</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.jiemo_vip"
              clearable
              placeholder="请选择">
              <el-option
                label="否"
                value="0"/>
              <el-option
                label="是"
                value="1"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('jiemo_contract_sign')">
            <label class="form-tit">芥末日本服务协议</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.jiemo_contract_sign"
              clearable
              placeholder="请选择">
              <el-option
                label="未确认"
                value="0"/>
              <el-option
                label="已确认"
                value="1"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('jiemo_vip_sign')">
            <label class="form-tit">芥末日本服务VIP协议</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.jiemo_vip_sign"
              clearable
              placeholder="请选择">
              <el-option
                label="未确认"
                value="0"/>
              <el-option
                label="已确认"
                value="2"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('short_study_abroad')">
            <label class="form-tit">短期留学</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.short_study_abroad"
              clearable
              placeholder="请选择">
              <el-option
                label="否"
                value="0"/>
              <el-option
                label="是"
                value="1"/>
            </el-select>
          </div>
          <div class="box-content" v-if="isTrainingSite">
            <label class="form-tit">咨询所属国家</label>
            <el-select
              v-model="searchData.sayerCountry"
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in ds.country"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('operateLastTime')">
            <label class="form-tit">用户运营最后回访时间</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.operateLastTime"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('take_order')">
            <label class="form-tit">是否已拍订单</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.take_order"
              clearable
              placeholder="请选择">
              <el-option
                label="否"
                value="0"/>
              <el-option
                label="是"
                value="1"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('take_order_number')">
            <label class="form-tit">已拍订单号</label>
            <el-input
              v-model.trim="searchData.take_order_number"
              class="jm-input-common"/>
          </div>

          <div
            class="box-content"
            v-if="isInWaters && filterVisible('timetosea')">
            <label class="form-tit">即将超时资源</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.timetosea"
              clearable
              placeholder="请选择">
              <el-option
                label="联系中超时"
                value="1"/>
              <el-option
                label="跟进型超时"
                value="2"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('hooli_grant')">
            <label class="form-tit">英澳申请Hooli</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.hooli_grant"
              clearable
              placeholder="请选择">
              <el-option
                label="已授权"
                value="1"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('is_interview')">
            <label class="form-tit">是否面试</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.is_interview"
              clearable
              placeholder="请选择">
              <el-option
                label="是"
                value="1"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('is_bind') && $hasPermission([20, 54, 81, 101])">
            <label class="form-tit">是否是被介绍人</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.is_bind"
              clearable
              placeholder="请选择">
              <el-option
                label="是"
                value="1"/>
              <el-option
                label="否"
                value="2"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('interview_way')">
            <label class="form-tit">面试方式</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              v-model="searchData.interview_way"
              dict-type="interview"
              name="interviewWay"
            />
          </div>
          <div
            class="box-content"
            v-if="filterVisible('hope_finish_school_time')">
            <label class="form-tit">择校期望时间</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.hope_finish_school_time"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input-common"/>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('student_level')">
            <label class="form-tit">客户评级</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              type="dataset"
              name="studentLevel"
              dict-type="student"
              v-model="searchData['student_level']"/>
          </div>

          <div
            class="box-content"
            v-if="filterVisible('korea_school_type')">
            <label class="form-tit">项目类型</label>
            <jm-dict-select
              class="jm-input-common"
              clearable
              v-model="searchData.korea_school_type"
              type="jiemo"
              dict-type="korea_school_type"
            />
          </div>
          <div
            class="box-content"
            v-if="filterVisible('kr_fir_id')">
            <label class="form-tit">韩国学校信息</label>
            <el-select
              v-model="searchData.kr_fir_id"
              filterable
              class="jm-input-common"
              clearable
              placeholder="请选择">
              <el-option
                v-for="item in schoolInfoKr"
                :label="item.value"
                :value="item.id"
                :key="item.id"/>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('money')"
          >
            <label class="form-tit">家庭可支配收入</label>
            <el-select
              class="jm-input-common"
              v-model="searchData.money"
              clearable
              placeholder="请选择">
              <el-option
                label="请选择"
                :value="0"></el-option>
              <el-option
                label="0-50万"
                :value="1"></el-option>
              <el-option
                label="50-100万"
                :value="2"></el-option>
              <el-option
                label="100-200万"
                :value="3"></el-option>
              <el-option
                label="200万以上"
                :value="4"></el-option>
            </el-select>
          </div>
          <div
            class="box-content"
            v-if="filterVisible('singapore_explain')">
            <label class="form-tit">新加坡说明</label>
            <el-select
              clearable
              class="jm-input-common"
              v-model="searchData.singapore_explain"
              placeholder="请选择">
              <el-option
                v-for="item in singapore_explain"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="box-content" v-if="filterVisible('is_default_visit') && $hasPermission([1])">
            <label class="form-tit">非默认回访</label>
            <el-switch
              active-text="筛选"
              inactive-text="不筛选"
              :active-value="1"
              :inactive-value="0"
              class="jm-input135"
              v-model="searchData.is_default_visit"/>
          </div>
          <div class="box-content" v-if="filterVisible('service_visit_log')">
            <label class="form-tit">客服筛选开关</label>
            <el-switch
              active-text="筛选"
              inactive-text="不筛选"
              :active-value="1"
              :inactive-value="0"
              class="jm-input135"
              v-model="searchData.service_visit_log"/>
          </div>
          <div class="box-content" v-if="filterVisible('service_visit_log_ts')">
            <label class="form-tit">客服回访时间</label>
            <el-date-picker
              :editable="false"
              v-model="searchData.service_visit_log_ts"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              class="jm-input-common"/>
          </div>
          <interview-search-form ref="interviewSearchForm" v-model="searchData.interviewForm" />
        </div>
        <!-- <div class="box-content" >
            <label class="form-tit">进入公海次数</label>
             <el-input v-model="searchData.giveupStart" class="jm-input-common" clearable placeholder="请输入内容"></el-input>
              <i>到</i>
              <el-input v-model="searchData.giveupEnd" class="jm-input-common" clearable placeholder="请输入内容"></el-input>
          </div> -->
        <div class="jm-primary jm-button-wrap">
          <el-button
            type="primary"
            :disabled="!canSearch"
            @click="doSearch">开始查询</el-button>
          <el-button
            class="jm-button-normal"
            type="primary"
            :disabled="!canSearch"
            @click="resetSearchData">清空条件</el-button>
          <batch-allot
            v-if="isAppAlloter"
            :disabled="disableBatchAllot"
            :data="selectedRows"
            :dataset="ds"
            @success="batchAllotSuccess"
          >批量分配</batch-allot>
          <el-button
            v-show="$hasPermission([154])"
            class="jm-button-normal"
            type="primary"
            :disabled="!canSearch"
            @click="fastSearch('not_role')">查看额外资源</el-button>
          <el-button
            class="jm-button-normal"
            v-if="!isFibSite"
            :disabled="!canSearch"
            type="danger"
            @click="showSyncDialog">批量同步到考培</el-button>
          <template v-if="isFibSite">
            <el-button
              v-if="$hasPermission('export_visit_0')"
              :disabled="!canSearch"
              type="primary"
              :loading="exporting"
              class="jm-button-normal"
              @click="exportVisit">导出回访记录</el-button>
            <el-button
              class="jm-button-normal"
              v-if="$hasPermission([30, 62])"
              type="primary" ><router-link
                target="_blank"
                :to="{ name: 'snapshot' }">重复资源记录管理</router-link></el-button>
          </template>
          <el-button
            class="jm-button-normal jm-button-search"
            @click="searchHidden">
            {{ searchHiddenLock ? '收回更多搜索' : '展开更多搜索' }}
            <i :class="searchHiddenLock ? 'active' : ''"></i>
          </el-button>
        </div>
      </div>
      <jm-tableList
        ref="stable"
        :url="pageTabelUrl"
        :inited.sync="tableListInited"
        :hide-opt-area="hideOptArea"
        :page-size="pageSize"
        :search-data="searchData"
        @selection-change="handleSelectionChange"
        row-key="id"
      >
        <el-table-column v-if="isAppAlloter" slot="firstColumn" type="selection" width="55"></el-table-column>
        <el-table-column
          slot="id"
          fixed
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          :min-width='140'
          class-name="scope-button-list jm-tac"
          property="id">
          <template slot-scope="scope">
            <div class="cell">
              <el-tag type="red" v-if="scope.row.is_new > 0">新</el-tag>
              <span style="display:inline-block;line-height:28px;margin-left:5px;">
                {{ scope.row.id }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          fixed
          slot="custom_name"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="custom_name">
          <template slot-scope="scope">
            <!-- <el-tag
              type="red"
              v-if="scope.row.is_new > 0">新</el-tag> -->
            <i
              class="name-tip-l"
              title="芥末注册用户"
              v-if="scope.row.userid > 0"/>
            <el-tag
              v-for="link in scope.row.link_others"
              :key="link.id"
              type="gray"
            >{{ getSiteTagByType(link.sync_type) }}</el-tag>
            <!--  <el-tag
              type="gray"
              v-if="scope.row.is_waters > 0">海</el-tag> -->
            <!-- <el-tag
              type="danger"
              v-if="scope.row.lv === 58">弃</el-tag> -->
            <!-- <el-tag
              type="gray"
              v-if="scope.row.wwad > 0 && scope.row.wwad < 4">旧</el-tag> -->
            <el-tooltip
              v-if="isFibSite"
              :disabled="!scope.row.crm_memo"
              effect="dark"
              :content="scope.row.crm_memo"
              placement="top-start">
              <router-link
                v-if="!scope.row.is_other"
                target="_blank"
                :to="{ name: 'editStudent', params: { id: scope.row.id } }">
                {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
              </router-link>
            </el-tooltip>
            <span v-else>
              {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
            </span>
            <span v-if="scope.row.is_other">
              {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          slot="last_service_log"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="last_service_log">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="!scope.row.last_service_log"
              effect="dark"
              placement="top-start">
              <span slot="content" v-html="scope.row.last_service_log"></span>
              <span>{{ scope.row.last_service_log | subStr }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          slot="crm_level_lv"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="crm_level_lv">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.crm_level_lv"
              :type="getResourceTag(scope.row.lv)">
              {{ scope.row.crm_level_lv }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          slot="custom_school"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="custom_school">
          <template slot-scope="scope">
            {{ scope.row.school }}
          </template>
        </el-table-column>
        <el-table-column
          slot="custom_major"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="custom_major">
          <template slot-scope="scope">
            {{ scope.row.major }}
          </template>
        </el-table-column>
        <el-table-column
          slot="lastvisittime2"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="lastvisittime2">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="!scope.row.lastvisitstr"
              effect="dark"
              :content="scope.row.lastvisitstr"
              placement="top-start">
              <span>{{ scope.row.lastvisittime2 }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <template v-if="isFibSite">
          <el-table-column
            slot="student_actions_count"
            slot-scope="scope"
            v-bind="scope.attrs"
            :label="scope.label"
            property="student_actions_count">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{ name: 'behavior', params: { id: scope.row.id } }">
                {{ scope.row.student_actions_count }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            slot="user_snapshot_count"
            slot-scope="scope"
            v-bind="scope.attrs"
            :label="scope.label"
            property="user_snapshot_count">
            <template slot-scope="scope">
              <router-link
                target="_blank"
                :to="{ name: 'resourceSnapshotList', params: { crmid: scope.row.id } }">
                {{ scope.row.user_snapshot_count }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            slot="jiemo_contract_sign"
            slot-scope="scope"
            v-bind="scope.attrs"
            :label="scope.label"
            property="jiemo_contract_sign">
            <template slot-scope="scope">
              <div
                v-html="scope.row.jiemo_contract_sign">
              </div>
            </template>
          </el-table-column>
          <template v-if="isFibSite">
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              min-width="400"
              align="left"
            >
              <template slot-scope="scope">
                <el-row v-if="!scope.row.is_other" class="index-table-btnwrap">
                  <el-button
                    v-if="$hasPermission(53) && scope.row.lv === 58"
                    size="mini"
                    type="success"
                    @click="visitHandle({ crmid: scope.row.id }, 'visit', '资源激活')">激活</el-button>
                  <el-button
                    v-if="$hasPermission(53) && scope.row.lv === 58"
                    size="mini"
                    type="danger"
                    @click="handleGiveUp(scope)">放弃</el-button>
                  <router-link
                    target="_blank"
                    :to="{ name: 'editStudent', params: { id: scope.row.id } }">
                    <el-button
                      size="mini"
                      type="primary">{{ readOnly ? '查看' : '编辑' }}</el-button>
                  </router-link>
                  <!-- <router-link
                    v-if="(!readOnly && !$hasPermission([20, 54])) || $hasPermission(1)"
                    target="_blank"
                    :to="{ name: 'paymentorder', params: { crmid: scope.row.id } }">
                    <el-button
                      size="mini"
                      type="primary">支付</el-button>
                  </router-link> -->
                  <el-button
                    v-if="(!readOnly && !$hasPermission([20, 54])) || $hasPermission(1)"
                    size="mini"
                    type="warning"
                    @click="visitHandle({ crmid: scope.row.id }, 'appointment', '预约回访')">预约</el-button>
                  <el-button
                    v-if="!readOnly && $hasPermission(117)"
                    size="mini"
                    type="success"
                    @click="visitHandle({ crmid: scope.row.id }, 'visit', '快捷回访', '', 'fibOperate')">回访</el-button>
                  <el-button
                    v-else-if="!readOnly"
                    size="mini"
                    type="success"
                    @click="visitHandle({ crmid: scope.row.id }, 'visit', '快捷回访')">回访</el-button>
                  <!--<a
                    v-if="!readOnly"
                    :class="scope.row.is_app > 0 ? 'btn-sendim' : 'btn-sendim active'"
                    @click="sendLock(scope.row.is_app, `${imUrl}&to=${scope.row.touserid}`)">
                    <el-button
                      :title="scope.row.is_app > 0 ? '' : '该学生还未登录过APP'"
                      size="mini"
                      type="primary">私信</el-button>
                  </a>-->
                  <el-button
                    size="mini"
                    type="danger"
                    v-if="$hasPermission(1)"
                    @click="handleDelete({ crmid: scope.row.id })">删除</el-button>
                  <el-button
                    size="mini"
                    type="success"
                    v-if="$hasPermission([20, 54, 43, 44, 45, 46])"
                    @click="showInterviewQrcode(scope.row.id)">二维码</el-button>
                  <router-link
                    v-if="$hasPermission([20, 101, 54, 43,149])"
                    :to="{ name: 'addBindStudent', params: { bindid: scope.row.id } }">
                    <el-button
                      size="mini"
                      type="primary"
                    >转介绍添加</el-button>
                  </router-link>
                  <el-button
                    v-if="$hasPermission([1, 62, 39]) || [455187, 2243703, 455174, 2263750, 2248733].indexOf(userInfo.userid) !== -1"
                    size="mini"
                    type="warning"
                    @click="bindHandle(scope.row.id, scope.row.custom_name)">介绍关系绑定
                  </el-button>
                  <el-button
                    v-if="scope.row.custom_promoter_int === $store.getters.userInfo.userid"
                    size="mini"
                    type="primary"
                    @click="openReuse(scope.row)">资源复用
                  </el-button>
                </el-row>
                <el-row v-if="scope.row.is_other && $hasPermission([117, 69])">
                  <router-link
                    target="_blank"
                    :to="{ name: 'editStudent', params: { id: scope.row.id } }">
                    <el-button
                      size="mini"
                      type="primary">查看</el-button>
                  </router-link>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              slot="student_actions_count"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="student_actions_count">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'behavior', params: { id: scope.row.id } }">
                  {{ scope.row.student_actions_count }}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              slot="user_snapshot_count"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="user_snapshot_count">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'resourceSnapshotList', params: { crmid: scope.row.id } }">
                  {{ scope.row.user_snapshot_count }}
                </router-link>
              </template>
            </el-table-column>
          </template>
        </template>
      </jm-tableList>
      <!--快捷回访 预约回访 父层组件 S-->
      <jm-visit-form-dialog
        :visible.sync="visitVisible"
        :title="visitDialogTitle"
        :type="visitType"
        :data-set="visitData"
        :operate-visit="userOperateVisit"
      />
    </el-tabs>
    <router-link target="_blank" :to="{ name: 'Plantasklist' }">
      <el-button
        class="edit-fixed"
        type="danger"
        size="mini"
      >待办<br/>事项</el-button>
    </router-link>
    <!--快捷回访 预约回访 父层组件 E-->
    <el-dialog width="30%" title="选择考培咨询" :visible.sync="syncToTrainingDialog">
      <el-select
        v-model="trainingTeacher"
        class="jm-input-common"
        clearable
        placeholder="请选择">
        <el-option-group
          v-for="(group, k) in trainingTeachers"
          :key="k"
          :label="k">
          <el-option
            v-for="item in group"
            :key="item.userid"
            :label="item.truename"
            :value="item.userid"/>
        </el-option-group>
      </el-select>
      <el-row>
        <el-col>同步到意向部门</el-col>
      </el-row>
      <el-radio-group v-model="targetCountry">
        <el-radio label="1868" :disabled="userInfo.countries.indexOf(1868) < 0 && !$hasPermission([1])">考培</el-radio>
        <el-radio label="2044" :disabled="userInfo.countries.indexOf(2044) < 0 && !$hasPermission([1])">英澳培训</el-radio>
        <el-radio label="1944" :disabled="userInfo.countries.indexOf(1944) < 0 && !$hasPermission([1])">高考日语线上</el-radio>
        <el-radio label="2043" :disabled="userInfo.countries.indexOf(2043) < 0 && !$hasPermission([1])">高考日语线下</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="() => { syncToTrainingDialog = false; }">取 消</el-button>
        <el-button type="primary" :disabled="targetCountry < 0" @click="doSyncingToTraining">确 定</el-button>
      </span>
    </el-dialog>
    <interview-qrcode-dialog :visible.sync="qrCodeDialogVisible" :crm-id="currentCrmId" />
    <!--绑定介绍人-->
    <bind-form-dialog :visible.sync="bindVisible" :show-data="bind" />
    <!--资源复用弹窗-->
    <el-dialog width="600px" title="资源复用" :visible.sync="reuseLock">
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">复用系统</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <jm-dict-select
            class="jm-input-common"
            :filter="(item) => item.id !== reuseForm.origin_tag"
            clearable
            type="jiemo"
            dict-type="site_name"
            name="site_name"
            value-type="String"
            v-model="reuseForm.target_tag"/>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">复用备注</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="reuseForm.memo"
            resize="none"
          >
          </el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 10px">
        <el-col :span="3" class="jm-tar" style="line-height: 35px">上传截图</el-col>
        <el-col :span="18" style="margin-left: 10px">
          <jm-upload
            class="reuse-uploader"
            action="/newfib.php/index/api_base/uploadSimpleFile/type/reuse"
            :show-file-list="false"
            :on-success="handleReuseSuccess"
            :before-upload="beforeReuseUpload">
            <img v-if="reuseForm.url" :src="reuseForm.url" class="reuse-img">
            <i v-else class="el-icon-plus reuse-uploader-icon"></i>
          </jm-upload>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReuse">取 消</el-button>
        <el-button type="primary" @click="saveReuse">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import visitFormDialog from '@/components/tool/visitFormDialog.vue';
import student from './student';
import { customLvType } from '@/dataset/student';
import { filterVisible, getSiteTagByType, isEmpty } from '@/utils/utils';
import { mapGetters } from 'vuex';
import {
  jmAreaselect,
  jmChannel,
  jmEducationSelect,
  jmExamjpSelect,
  jmDictSelect
} from '@/components/tool';
import interviewSearchForm from './components/interviewSearchForm';
import permissionMixin from './permissionMixin';

const interviewQrcodeDialog = () => import('./components/interviewQrcodeDialog.vue');
const bindFormDialog = () => import('./components/bindFormDialog.vue');
const BatchAllot = () => import('./components/batchAllot.vue');

let data = {};
const exData = {
  pageSize: 20,
  dataListVal: [], // 子层刷新数据
  tableListDataVal: [], // tablelist列表数据
  subscribeData: [], // 弹层数据 预约回访
  IshandleAppointment: false,
  IsHandleVisit: false,
  advisoryTeacher: [], // 咨询老师
  updateEdit: {}, // 学生回访列表 单个编辑数据
  area1: [],
  subeducation: [],
  schoolInfo: [], // 选校信息
  showCrmSchool: true,
  education: [], // 学历
  examjp: [], // 日语成绩
  tableListInited: false,
  hideOptArea: false,
  exporting: false,
  activeName: 'first',
  syncToTrainingDialog: false, // 批量同步蓝火到考培时，可以选择考培老师
  trainingTeacher: -1, // 批量同步到考培时候，分配的咨询老师
  targetCountry: -1, // 批量同步到到考培时候，分配的意向部门（国家）
};
// 数据源
data.ds = {
  country: [], // 意向国家
  education: ['', ''], // 最高学历
  subeducation: [] // 学历内容
};
// 手机号归属地数据源
data.phoneOwnership = {
  area: {},
  provinces: [],
  cities: []
};
/**
 * v-model 数据源
 */
data.searchData = {
  isSearch: false,
  name: '',
  nameString: '',
  linklike: '',
  birthday: '',
  lastSchool: '',
  lastSchoolInput: '',
  have_offer_status: '',
  custom_major: '',
  WeChat: '',
  signingStatus: '',
  signingdate: [],
  crm_document: '',
  create_person: '', // 创建人
  no_create_person: '', // 创建人
  create_point: [], // 采集功能
  create_point_ex: false, // false包含，true排除
  custom_promoter: [], // 推广人
  custom_promoter_ex: false, // false包含，true排除
  reviewStar: '',
  selectPlan: '',
  returnNumber1: '',
  returnNumber2: '',
  nickname: '',
  phone: '',
  phoneProvince: '', // 手机号归属地省
  phoneCity: '', // 手机号归属地市
  average: '',
  customerClassification: [], // 客户分级
  crm_writer: '', // 申请老师
  crm_cse: '', // 客服老师
  crm_planning: '', // 规划老师
  creationDate: [],
  transferredResources: false,
  studentsDynamic: '',
  studentsDynamicDate: '',
  returndate: '',
  custom_course: null,
  gender: '',
  highestRecord1: '',
  highestRecord2: '',
  setexamjp1: '',
  setexamjp2: '',
  qq: '',
  examScore: '',
  intentionCountries: [], // 意向国家
  intentionCountriesEx: false, // false包含，true排除
  activeCountries: [], // 办理国家
  activeCountriesEx: false, // false包含，true排除
  contractNo: '',
  crm_sayer: '',
  schoolInformation: '',
  lastvisittime2: '',
  dataSent: '',
  project: '',
  endorsePlan: '',
  returnRecord: '',
  startSchoolDateYear: '', // 入学日期
  startSchoolDateMonth: '', // 入学日期
  no_custom_year: false, // 入学时间为空
  showIgnore: false, // 显示放弃
  domicile: '', // 户籍地
  currentAddress: '', // 现住址
  excludeSelf: false, // 排除自己
  // 渠道
  channel: {
    custom_from: '',
    custom_from_sub: '',
    custom_from_thrid: '',
    custom_from_fourth: '',
    custom_from_fifth: ''
  },
  id: '', // 客户编码
  upgradePlanTeacher: '', // 升学指导老师
  joinUpgradePlan: false, // 参加1对1升学规划
  sendUpgradePlan: false, // 发送升学规划书
  testUpgradePlan: false, // 参加试听课程
  school_schedule: null, // 留学时刻表
  signTypeLevel: null,
  identity: '',
  signTypeKind: [],
  InternationalWaters: '', // 公海资源管理
  behaviorStart: '', // 用户行为数
  behaviorEnd: '', // 用户行为数
  isJpHas: '', // 是否有日语成绩
  activationStart: '', // 激活次数
  activationEnd: '', // 激活次数
  signTheContract: '', // 考培签约
  examinationOfCulture: '', // 考培分级
  jiemo_vip: '', // 芥末日本vip
  jiemo_contract_sign: '', // 芥末日本服务协议
  short_study_abroad: '', // 短期留学
  clues_level: 0, // 线索分级
  custom_jp_note: null, // 留学目的
  activity_code: '', // 活动编码
  jiemo_vip_sign: '', // 芥末日本服务VIP协议
  take_order: '', // 是否已拍订单
  take_order_number: '', // 已拍订单号
  hooli_grant: '',
  is_interview: '', // 是否面试
  is_bind: '', // 是否是被介绍人
  interview_way: '', // 面试方式
  interviewForm: {},
  hope_finish_school_time: [], // 择校期望完成时间
  student_level: '请选择', // 客户评级
  singapore_explain: '', // 新加坡说明
  korea_school_type: '无', // 学校类型
  kr_fir_id: '', // 韩国学校信息
  apply_school: '', // 申请学校
  is_parent_community: -1, // 家长社群
  is_vip: -1, // 芥末会员
  is_default_visit: '0', // 非默认回访
};
data = Object.assign(data, exData);

export default {
  data() {
    return {
      ...data,
      searchHiddenLock: false, // 搜索区域显示锁
      isInWaters: true,
      waterNewCounts: 0,
      qrCodeDialogVisible: false,
      bindVisible: false,
      bind: {
        bindCrmId: 0,
        bindName: ''
      },
      currentCrmId: 0,
      singapore_explain: [{
        value: '新加坡',
        label: '新加坡'
      }, {
        value: '马来西亚',
        label: '马来西亚'
      }],
      searchKey: {},
      searchKeyTools: [],
      selectedRows: [], // 存储选中资源
      reuseLock: false, // 资源复用弹窗锁
      reuseForm: {
        origin_tag: process.env.VUE_APP_SITE_NAME,
        origin_id: '',
        target_tag: '',
        memo: '',
        path: '',
        url: '',
      }, // 资源复用表单
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmAreaselect,
    jmVisitFormDialog: visitFormDialog,
    jmChannel,
    jmEducationSelect,
    jmDictSelect,
    jmExamjpSelect,
    interviewSearchForm,
    interviewQrcodeDialog,
    bindFormDialog,
    BatchAllot,
  },
  // beforeRouteEnter(to, from, next) {
  //   if (window.screen.width < 1025) {
  //     window.location.href = "/frontend/h5/tools"
  //   }
  // },
  beforeRouteLeave(to, from, next) {
    this.ds.schoolInfo = [];
    next();
  },
  methods: {
    // 资源复用相关
    openReuse(row) {
      this.reuseForm = {
        origin_tag: process.env.VUE_APP_SITE_NAME,
        origin_id: row.id,
        target_tag: '',
        memo: '',
        path: '',
        url: '',
      };
      this.reuseLock = true;
    },
    closeReuse() {
      this.reuseLock = false;
    },
    saveReuse() {
      if (!this.reuseForm.target_tag) {
        this.$message.error('请选择系统');
        return false;
      }
      if (!this.reuseForm.memo) {
        this.$message.error('请填写备注');
        return false;
      }
      if (!this.reuseForm.path) {
        this.$message.error('请上传截图');
        return false;
      }
      this.$http
        ._post({
          url: '/index/reuse/save',
          data: this.reuseForm
        })
        .then(() => {
          this.$message.success('保存成功');
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
      this.closeReuse();
    },
    handleReuseSuccess(res /* , file */) {
      this.reuseForm.path = res.data.path;
      this.reuseForm.url = res.data.url;
    },
    beforeReuseUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB');
      }
      return isJPG && isLt2M;
    },
    bindHandle(id, name) {
      this.bindVisible = true;
      this.bind.bindCrmId = id;
      this.bind.bindName = name;
    },
    // 是否能查看‘放弃’客户分级
    crmLvFilter(item) {
      let isMaster = this.$hasPermission([1, 30, 77, 62, 89, 81, 91, 69, 117, 154]);
      let isLeader = this.$hasPermission([33, 39], true); // 日本主管，前程日本主管

      switch (item.value) {
        case 58: // 放弃
          return isMaster || isLeader;
        case 66: // 最终放弃
          return isMaster;
        default:
          return true;
      }
    },
    changeTab(tab) {
      if (tab.name === 'second') {
        this.isInWaters = false;
        this.resetSearchData();
        this.searchData.InternationalWaters = 1;
        this.doSearch();
      } else {
        this.isInWaters = true;
        this.resetSearchData();
        this.doSearch();
      }
    },
    crmKaopeiFilter(item) {
      if (
        item.value === 66 ||
        item.value === 64 ||
        item.value === 62 ||
        item.value === 62 ||
        item.value === 60
      ) {
        return false;
      }
      return true;
    },
    // 私信点击事件，兼容火狐用
    sendLock(val, href) {
      if (val === null) {
        return false;
      } else if (val > 0) {
        window.open(href);
      }
    },
    getResourceTag(lv) {
      let type = '';
      switch (lv) {
        case 65:
          type = 'danger';
          break;
        case 57:
          type = 'success';
          break;
        case 53:
          type = 'warning';
          break;
        default:
          type = 'info';
          break;
      }
      return type;
    },
    refreshList() {
      this.$store.commit('updateRefresh', true);
    },
    initFastSeach() {
      this.$http
        ._get({
          url: '/index/student/searchTools'
        })
        .then(({ data }) => {
          this.searchKey = data.searchData;
          this.searchKeyTools = data.key;
        });
    },
    fastSearch(key) {
      if (this.searchKey[key]) {
        this.resetSearchData();
        this.searchData = Object.assign({}, this.searchData, this.searchKey[key]);
        this.doSearch();
      }
    },
    /**
     * 最高学历联动
     */
    getSubRecoreWrap(v) {
      this.getSubRecore(v);
    },
    /**
     * 清空自定义搜索条件
     */
    resetSearchData() {
      Object.keys(this.searchData).forEach((key) => {
        if (typeof this.searchData[key] !== 'object') {
          this.searchData[key] = '';
        }
      });
      // this.searchData.channel = '';
      this.education = [null, null];
      this.examjp = [null, null];
      this.searchData.creationDate = [];
      this.searchData.returndate = [];
      this.searchData.giveup_time = [];
      this.searchData.signingdate = [];
      this.searchData.lastvisittime2 = [];
      this.searchData.studentsDynamicDate = [];
      this.searchData.create_point = []; // 采集功能
      this.searchData.create_point_ex = false; // false包含，true排除
      this.searchData.activeCountries = '';
      this.searchData.activeCountriesEx = false;
      this.searchData.intentionCountries = '';
      this.searchData.intentionCountriesEx = false; // false包含，true排除
      this.searchData.custom_promoter = []; // 推广人
      this.searchData.custom_promoter_ex = false; // false包含，true排除
      this.phoneOwnership.cities = [];
      this.searchData.domicile = [null, null];
      this.searchData.currentAddress = [null, null];
      this.searchData.channel.custom_from = '';
      this.searchData.signTypeLevel = null;
      this.searchData.signTypeKind = [];
      this.searchData.culture_sign_date = [];
      this.searchData.operateLastTime = [];
      this.searchData.no_create_person = [];
      this.searchData.hope_finish_school_time = [];
      this.searchData.is_parent_community = -1;
      this.searchData.is_vip = -1;
      this.searchData.internationalWatersRule = '';
      if (!this.isInWaters) {
        this.searchData.InternationalWaters = 1;
      }
      // 面试报名表
      if (this.$refs.interviewSearchForm) {
        this.$refs.interviewSearchForm.reset();
      }

      this.refreshList();
    },
    /**
     * 择校规划 已签约未做择校规划 当是 -1 从新赋值为 7
     */
    selectPlanEvent(value) {
      this.searchData.signingStatus = '';
      this.searchData.have_offer_status = this.searchData.selectPlan;
      if (value === -1) {
        this.searchData.signingStatus = 7;
        this.searchData.have_offer_status = 1;
      }
    },
    setEducation(value) {
      this.searchData.highestRecord1 = value[0];
      this.searchData.highestRecord2 = value[1];
    },
    setExamjp(value) {
      this.searchData.setexamjp1 = value[0];
      this.searchData.setexamjp2 = value[1];
    },
    fetchCrmTelArea() {
      this.$http
        ._get({
          url: '/index/api_base/fetchCrmTelArea'
        })
        .then(({ data }) => {
          this.phoneOwnership.area = data;
          this.phoneOwnership.provinces = Object.keys(data);
        });
    },
    changePhoneProvince(v) {
      this.searchData.phoneCity = '';
      this.phoneOwnership.cities = this.phoneOwnership.area[v];
    },
    filterVisible,
    doSearch() {
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.refreshList();
    },
    exportVisit() {
      this.exporting = true;
      this.$http
        ._post({
          url: '/index/student/createVisitRecordExcel',
          data: this.searchData
        })
        .then(({ data }) => {
          this.exporting = false;
          this.$http._download({
            filename: data,
            download: '回访记录.xlsx'
          });
        })
        .catch(() => {
          this.$message.error('可能数据太多了。。。');
        });
    },
    /**
     * 更改放弃时间搜索
     */
    changeGiveupTime(v) {
      if (v) {
        this.searchData.customerClassification = [58];
        return true;
      }
      this.searchData.customerClassification = [];
    },
    inputAreaKeyup() {
      this.refreshList();
    },
    showSyncDialog() {
      this.syncToTrainingDialog = true;
    },
    /**
     * 考培站点，批量同步资源到考培
     */
    batchSyncToTraining() {
      this.$confirm('确认将所查资源信息批量同步到考培系统吗？', {
        type: 'warning',
      }).then(() => {
        this.doSyncingToTraining();
      }).catch(() => {
        console.log('cancel sync');
      });
    },
    /**
     * 批量同步到考培
     */
    doSyncingToTraining() {
      // if (this.trainingTeacher <= 0) {
      //   this.$message.error('请选择考培咨询');
      //   return false;
      // }
      this.syncToTrainingDialog = false;
      const syncingMsg = this.$message({
        message: '同步中...',
        duration: 0
      });
      this.$http._post({
        url: '/training/customer/batchSync',
        data: {
          searchData: this.searchData,
          trainingTeacher: this.trainingTeacher,
          targetCountry: this.targetCountry
        }
      }).then(() => {
        syncingMsg.close();
        this.$message.success('同步成功！');
        this.refreshList();
        this.trainingTeacher = null;
      });
    },
    getSiteTagByType,
    /**
     * 获取新资源数量
     */
    getNewCounts() {
      this.$http._get({
        url: '/index/student/getnewcount',
      }).then(({ data }) => {
        this.waterNewCounts = data;
      });
    },
    /**
     * 报名表专属二维码
     */
    showInterviewQrcode(id) {
      this.qrCodeDialogVisible = true;
      this.currentCrmId = id;
    },
    /**
     * 搜索区域显隐
     */
    searchHidden() {
      this.searchHiddenLock = !this.searchHiddenLock;
    },
    /**
     * 多选资源
     */
    handleSelectionChange(rows) {
      if (!isEmpty(rows)) {
        this.selectedRows = rows.map(({ id }) => {
          return id;
        });
        return true;
      }
      this.selectedRows = [];
    },
    batchAllotSuccess() {
      this.refreshList();
      this.selectedRows = [];
    }
  },
  computed: {
    customLvTypeDs() {
      return customLvType.filter(this.crmLvFilter);
    },
    schoolInfoKr() {
      if (this.ds.schoolInfo) {
        return this.ds.schoolInfo.filter((item) => {
          return item.sh_country === 2047;
        });
      }
      return [];
    },
    qrcodeUrl() {
      if (this.channelData && this.channelData.ch_qrurl) {
        return this.channelData.ch_qrurl;
      }
      return '';
    },
    refresh() {
      return this.$store.state.student.refresh;
    },
    createPersonZZ() {
      if (this.ds.create_person && this.ds.create_person.ZZ) {
        return this.ds.create_person.ZZ.filter(item => item.userid < 0);
      }
      return [];
    },
    pageTabelUrl() {
      return this.isFibSite ? '/index/student/pagetable' : '/training/customer/resourceList';
    },
    /**
     * 考培咨询老师
     */
    trainingTeachers() {
      let currentTeachers = { ...this.ds.training_teacher };
      if (this.$hasPermission([91, 139])) {
        Object.entries(currentTeachers).forEach(([char, teacher]) => {
          teacher = teacher.filter((t) => {
            if (t.userid === -1) {
              return true;
            }
            return (this.userInfo.countries.indexOf(t.country) >= 0);
          });
          currentTeachers[char] = teacher;
          if (teacher.length === 0) {
            delete currentTeachers[char];
          }
        });
      }
      return { A0: [{ truename: '自动分配', userid: -1 }], ...currentTeachers };
    },
    disableBatchAllot() {
      return isEmpty(this.selectedRows);
    },
    ...mapGetters(['userInfo', 'imUrl']),
  },
  mounted() {
    // 待激活咨询显示放弃资源
    if (this.$hasPermission(53) && !this.$hasPermission(1)) {
      this.searchData.showIgnore = true;
    }
    this.getDatasource();
    this.fetchCrmTelArea();
    // this.getWatersMes();
    this.getNewCounts();
    if (this.$route.query.InWaters) {
      this.activeName = 'second';
      this.isInWaters = false;
      this.resetSearchData();
      this.doSearch();
    }
    this.initFastSeach();
  },
  mixins: [student, permissionMixin]
};
</script>
<style>
.name-tip-l {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 15px;
  background-color: #3368fa;
  border-radius: 2px;
  margin-right: 5px;
}
.scope-button-list .cell {
  display: flex;
  justify-content: space-around;
}

.box-content-double .el-checkbox__label {
  color: #f60;
}
.button-search {
  margin-right: 10px;
  display: inline-block;
  height: 100%;
}
.button-search:last-of-type {
  margin-left: 3px;
}
.reuse-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.reuse-uploader .el-upload:hover {
  border-color: #409EFF;
}
.reuse-uploader-icon {
  display: inline-block;
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.reuse-img {
  max-width: 150px;
  display: block;
}
</style>

<style scoped>
.notice-big-wapper {
  background: #fff;
}
.notice-wapper,
.rank-wapper {
  padding: 16px;
}
.notice-right {
  width: 400px;
  border: 1px solid #409eff;
  padding-bottom: 10px;
}
.notice-right > div {
  padding: 0 10px;
}
.notice-right h2 {
  text-align: center;
  color: #409eff;
  margin: 10px 0;
}
.notice-right p {
  line-height: 26px;
  font-size: 12px;
}
.notice-right span {
  color: red;
}
.notice-right i {
  font-weight: 600;
}
.notice-right em {
  color: #666;
}
.notice-wapper::after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
}
.get-group {
  margin-bottom: 78px;
}
.get-group span {
  margin-left: 16px;
}
.get-group span em {
  color: #409eff;
}
.rank-num > div {
  margin-right: 30px;
  text-align: center;
  color: #409eff;
}
.rank-num > div p:nth-of-type(1) {
  font-size: 18px;
  margin-bottom: 6px;
}
.rank-num > div p:nth-of-type(2) {
  font-size: 12px;
}
.btn-sendim.active {
  cursor: not-allowed;
}
.btn-sendim.active button {
  background: #999;
  border-color: #999;
  cursor: not-allowed;
}
.no-content-item {
  color: #f60;
}
.box-radio-checkbox .el-radio-group {
  display: inline-block;
}
.box-radio-checkbox .el-checkbox-group {
  display: inline-block;
}
.operate-td .cell .el-row > a {
  display: none ;
}
.operate-td .cell .el-row > button {
  display: none ;
}
.operate-td .cell .el-row > a:first-child {
  display: block ;
}

.search-input-wrap{
  max-height: 450px;
  overflow: hidden;
}
.search-input-wrap.active{
  max-height: none;
}
.search-input-wrap::after{
  content: "";
  display: block;
  clear: both;
}

</style>
